module.exports = __webpack_public_path__ + "img/repartidor.8fe09986.png";